import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  constructor(
    private api: ApiService,
    private util: UtilService,
    private http: HttpClient
  ) {}

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }
  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  updateUserStatus(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.ADMIN.UPDATE_USER_STATUS, postData );
  }
  sendEmail(data :any)
  {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.ADMIN.SEND_EMAIL, postData );

  }
  checkDuplicateEmail(email: string, orgId: number, excludeUserId?: number) {
    const postData: APIRequest = {
      requestBody: {
        email,
        orgId: orgId,
        excludeUserId: excludeUserId || null
      }
    };
    return this.api.post(URL.ADMIN.CHECK_DUPLICATE_EMAIL, postData);
  }
  sendSMS(data :any)
  {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.ADMIN.SEND_SMS, postData );

  }
  saveUserLoginCredentials(data: any) {
    const postData: APIRequest = {
       
      requestBody: {
        ...data,
        orgId: parseInt(this.orgID, 10),
      }
    };
    
    return this.api.post(URL.ADMIN.SAVE_LOGIN_CREDENTIALS, postData );
  }
  
  sendVerificationEmail(email: string, fullName: string,org_Id:any) {
    const frontendUrl = window.location.origin;
    const postData: APIRequest = {
      requestBody: {
        email,
        fullName,
        org_id: parseInt(org_Id),
        frontendUrl 
      }
    };
    console.log('postData', postData);
    return this.api.post(URL.ADMIN.SEND_VERIFICATION_EMAIL, postData );
  }
  
  getOrgUsersPaginated(page: number, limit: number, filters?: {
    search?: string | null;
    roleId?: number | null;
    categoryId?: number | null;
    status?: string | null;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    customAttr?: string | null;
    createdFrom?: string | null;
    createdTo?: string | null;
    lastLoginFrom?: string | null;
    lastLoginTo?: string | null;
  }) {
    const f = filters || {};
    const params: string[] = [];
    params.push(`page=${page}`);
    params.push(`limit=${limit}`);
    if (f.search) params.push(`search=${encodeURIComponent(f.search)}`);
    if (f.roleId) params.push(`roleId=${f.roleId}`);
    if (f.categoryId) params.push(`categoryId=${f.categoryId}`);
    if (f.status) params.push(`status=${encodeURIComponent(f.status)}`);
    if (f.name) params.push(`name=${encodeURIComponent(f.name)}`);
    if (f.email) params.push(`email=${encodeURIComponent(f.email)}`);
    if (f.phone) params.push(`phone=${encodeURIComponent(f.phone)}`);
    if (f.customAttr) params.push(`customAttr=${encodeURIComponent(f.customAttr)}`);
    if (f.createdFrom) params.push(`createdFrom=${encodeURIComponent(f.createdFrom)}`);
    if (f.createdTo) params.push(`createdTo=${encodeURIComponent(f.createdTo)}`);
    if (f.lastLoginFrom) params.push(`lastLoginFrom=${encodeURIComponent(f.lastLoginFrom)}`);
    if (f.lastLoginTo) params.push(`lastLoginTo=${encodeURIComponent(f.lastLoginTo)}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.api.get(`${URL.ADMIN.GET_ORG_USERS_PAGINATED}${qs}`);
  }

  getEmailVerificationStatus(email: string) {
    const postData: APIRequest = {
      requestBody: {
        email,
        org_id: parseInt(this.orgID, 10),
      }
    };
    return this.api.post(URL.ADMIN.GET_EMAIL_VERIFICATION_STATUS, postData );
  }

  verifyEmailByToken(token: string) {
    const postData = { requestBody: { token } };
    return this.api.post(URL.ADMIN.VERIFY_EMAIL_BY_TOKEN, postData);
  }

  resendVerificationEmail(email: string, fullName: string,org_id:any) {
    const frontendUrl = window.location.origin;
    const postData: APIRequest = {
      requestBody: {
        email,
        fullName,
        org_id:parseInt(org_id),
        frontendUrl
      }
    };
    return this.api.post(URL.ADMIN.RESEND_VERIFICATION_EMAIL, postData);
  }
}
